import React from 'react';
import styles from './search-satisfaction.module.scss';

export const SearchSatisfaction = () => (
  <div
    className={`searchSatisfactionContainer ${styles.searchSatisfactionRoot}`}
    id="searchSatisfaction"
    data-testid="searchSatisfaction"
  />
);
